import { render } from "./SettingsProviderComponent.vue?vue&type=template&id=c40ec660&scoped=true"
import script from "./SettingsProviderComponent.vue?vue&type=script&lang=js"
export * from "./SettingsProviderComponent.vue?vue&type=script&lang=js"

import "./SettingsProviderComponent.vue?vue&type=style&index=0&id=c40ec660&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c40ec660"]])

export default __exports__